import type { FulfillmentBoardQueryDTO } from "@/modules/fulfillment/domain/contracts";
import type { FulfillmentBoardResult, PackQueueResult } from "@/modules/fulfillment/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type FulfillmentBoardQuery = FulfillmentBoardQueryDTO;

export const fulfillmentApi = {
  async board(query?: FulfillmentBoardQuery): Promise<FulfillmentBoardResult> {
    const url = new URL(`${config.apiUrl}/fulfillment/board`);
    if (query?.scope) url.searchParams.set("scope", query.scope);
    return fetcher.get(url.toString());
  },
  async packQueue(): Promise<PackQueueResult> {
    return fetcher.get(`${config.apiUrl}/fulfillment/pack`);
  },
};
